define('directives/jquery/ngJqUpload',[
	"application",
	"jquery",
	"jquery.fileupload"
], function (app, $) {

	return app.directives.directive("ngJqUpload", function () {

		return {
			restrict: "A",
			link: function ($scope, $element, attrs) {
				var originalAdd = $.blueimp.fileupload.prototype.options.add;
				var maxFileSize = attrs.ngJqUploadMaxFileSize;
				var add = function (e, data) {
					if (maxFileSize && data.originalFiles[0] && data.originalFiles[0]['size'] > maxFileSize) {
						if (failCallback) {
							data.errorThrown = "MAX_SIZE_EXCEEDED";
							$scope.$eval(failCallback, { $data: data });
						}

						return false;
					}
					else
						originalAdd.call(this, e, data);
				}

				var startCallback = attrs.ngJqUploadStarting;
				var successCallback = attrs.ngJqUploadSuccess;
				var failCallback = attrs.ngJqUploadError;
				var endCallback = attrs.ngJqUploadEnd;
				var progressCallback = attrs.ngJqUploadProgress;

				attrs.$observe("ngJqUpload", function (url) {
					if (url)
						$element.fileupload({
							dataType: "json",
							url: url,
							add: add
						});
				});


				$element.on("fileuploaddone", function (e, data) {
					if (successCallback)
						$scope.$eval(successCallback, { $data: data.result });
				});

				$element.on("fileuploadfail", function (e, data) {
					if (failCallback)
						$scope.$eval(failCallback, { $data: data });
				});

				$element.on("fileuploadstart", function (e, data) {
					if (startCallback)
						$scope.$eval(startCallback, { $data: data });
				});

				$element.on("fileuploadalways", function (e, data) {
					if (endCallback)
						$scope.$eval(endCallback);
				});

				$element.on("fileuploadprogressall", function (e, data) {
					if (progressCallback) {
						var progress = (data.loaded / data.total) * 100;
						$scope.$eval(progressCallback, { $data: progress });
					}
				});

			}
		};

	});

});
